<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelOption"
    :allowEmpty="isMulti ? true : false"
    :preselectFirst="false"
    :loading="isLoading"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    :multiple="isMulti ? true : false"
    :taggable="isTagabble ? true : false"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    placeholder=""
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ emptyLabel ? $t(emptyLabel) : '' }}</span>
    </template>
    <template v-if="isMulti" slot="tag" slot-scope="{ option }"
      ><span class="badge badge-primary mr-1"
        ><span class="text-truncate mr-1 mb-1">{{ option.nome }}</span
        ><span class="custom__remove badge" @mousedown.prevent.stop="removeOption(option)">x</span></span
      ></template
    >
    <template slot="clear" slot-scope="props">
      <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isDisabled', 'emptyLabel', 'isMulti', 'isTagabble'],
  data() {
    return {
      selected: this.isMulti ? [] : null,
      options: [],
      isLoading: false
    };
  },
  methods: {
    onChange(e) {
      this.$emit('input', e);
      this.$emit('selectChange', 'tipo_venda_loterico', e);
    },
    labelOption({ nome }) {
      return `${nome}`;
    },
    setOptions() {
      this.isLoading = true;
      this.options = [
        { id: '101', nome: '101 - Débito Loteria Popular' },
        { id: '102', nome: '102 - Débito Fazendinha' },
        { id: '103', nome: '103 - Débito Lotéricos' }
      ];
      this.setValue(this.nameField);
      this.isLoading = false;
    },
    setValue(value) {
      if (this.isMulti) {
        if (Array.isArray(value)) {
          this.selected = this.options.filter((option) => value.find((item) => item.id === option.id));
        } else if (typeof value === 'string') {
          const ids = value.split(',').map((item) => item.trim());
          this.selected = this.options.filter((option) => ids.includes(option.id));
        } else {
          this.selected = [];
        }
        this.$emit('input', this.selected);
        return;
      }
      if (value && value.id) {
        this.selected = this.options.find((option) => option.id === value.id);
      } else if (value) {
        this.selected = this.options.find((option) => option.id === value);
      } else {
        this.selected = null;
      }
      this.$emit('input', this.selected);
    },
    clearAll() {
      if (this.isMulti) {
        this.selected = [];
      } else {
        this.selected = null;
      }
      this.$emit('input', this.selected);
      this.$emit('selectChange', 'tipo_venda_loterico', this.selected);
    },
    removeOption(option) {
      if (!option) return;
      if (this.isMulti && Array.isArray(this.selected)) {
        this.selected = this.selected.filter((item) => item.id !== option.id);
        this.$emit('input', this.selected);
        this.$emit('selectChange', 'tipo_venda_loterico', this.selected);
      }
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.multiselect__clear::before {
  color: #26b4ff;
}
.custom__remove {
  background: #26b4ff !important;
  color: #fff;
  transition: ease 0.2s all;
}
.custom__remove:hover {
  cursor: pointer;
  background: #0097e9 !important;
}
</style>
